import { render } from "./EditFiles.vue?vue&type=template&id=79291d24&scoped=true"
import script from "./EditFiles.vue?vue&type=script&lang=js"
export * from "./EditFiles.vue?vue&type=script&lang=js"

import "./EditFiles.vue?vue&type=style&index=0&id=79291d24&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79291d24"]])

export default __exports__